$('.slider-grid').slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    autoplay: true,
    speed: 500,
    arrows: true,
    prevArrow: `<button type="button" class="slick-prev slick-arrow col-slider" aria-label="Previous"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</path></svg>
</button>`,
    nextArrow: `<button class="slick-next slick-arrow col-slider" aria-label="Next" type="button"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</path></svg>
   </button>`,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
            autoplay: true,
            arrows: false,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 767,
        settings: {
            autoplay: true,
            adaptiveHeight: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
    ]
});


$('.marquee').slick({
    speed: 14000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
});


 function openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
     $('.product-slider').slick('unslick');
     slider();
  }
  setTimeout(function(){

  var elements = document.getElementsByClassName('openDefault');

  for (let i = 0; i < elements.length; i++) {
    elements[i].click();
  }
  },2000)

slider();
function slider(){
$('.product-slider').not('.slick-initialized').slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: true,
    autoplay: false,
    speed: 500,
    arrows: true,
    prevArrow: `<button type="button" class="slider-button slider-button--prev">
<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</path>
</svg>
</button>`,
    nextArrow: `<button type="button" class="slider-button slider-button--next">
            <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</path></svg>
</button>`,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            autoplay: true,
            arrows: false,
            adaptiveHeight: true,
            slidesToScroll: 3
        }
    },
    {
        breakpoint: 767,
        settings: {
            autoplay: false,
            arrows: false,
            slidesToShow: 2,
            adaptiveHeight: true,
            slidesToScroll: 2
        }
    }
    ]
});
}